<template>
  <jczh-drawer
    :visible.sync="drawerVisible"
    title="申请开票"
    confirm-button-text="确定申请"
    size="600px"
    @close="handleDrawerClose"
    @confirm="confirmApply"
  >
    <template v-slot:content>
      <el-form
        class="m-t-10"
        label-suffix="："
        size="small"
        label-position="right"
        label-width="120px"
      >
        <el-form-item v-if="showInvoiceTitleSelect" label="抬头类型">
          <el-radio-group v-model="invoiceTitle">
            <el-radio
              v-for="item in invoiceTitleTypeDict.array"
              :key="item.value"
              :label="item.value"
            >{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showCompanySelect" label="选择开票企业">
          <el-select v-model="invoiceIndex" style="width: 300px" size="mini">
            <el-option
              v-for="(item, index) in invoiceTitleList"
              :key="index"
              :label="item.invoiceName"
              :value="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="showInvoiceTypeRadio" label="选择发票类型">
          <el-radio-group v-model="invoiceType">
            <el-radio
              v-for="item in invoiceTypeList"
              :key="item.value"
              :label="item.value"
            >{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <personal-invoice
        v-if="inPersonalInvoice"
        ref="personalInvoice"
        class="m-t-24"
        @getInvoiceInfo="getInvoiceInfo"
      />

      <template v-else>
        <general-invoice
          v-if="inGeneralInvoice"
          ref="generalInvoice"
          class="invoice-wrapper m-t-20"
          :company-id="currentInvoiceTitle.companyId"
          :invoice-address-id="currentInvoiceTitle.invoiceAddressId"
          :is-employee="Boolean(companyId)"
          :is-show-title="false"
          @getInvoiceInfo="getInvoiceInfo"
        />

        <special-invoice
          v-else
          ref="specialInvoice"
          class="m-t-20"
          :company-id="currentInvoiceTitle.companyId"
          :invoice-address-id="currentInvoiceTitle.invoiceAddressId"
          :is-employee="Boolean(companyId)"
          :is-show-title="false"
          @getInvoiceInfo="getInvoiceInfo"
        />
      </template>
    </template>
  </jczh-drawer>
</template>

<script>
import { mapState } from 'vuex'
import GeneralInvoice from '@/components/PersonalCenter/GeneralInvoice'
import SpecialInvoice from '@/components/PersonalCenter/SpecialInvoice'
import PersonalInvoice from '@/components/PersonalCenter/PersonalInvoice'
import {
  feeTypeDict,
  invoiceTitleTypeDict,
  invoiceTypeDict,
  isWhetherOurCompanyDict
} from '@/dictionary/financial'
import { applyInvoiceApi } from '@/api/financial/financial'
import { getInvoiceCompanyApi } from '@/api/financial/invoice'

export default {
  name: 'ApplyInvoiceDrawer',

  components: {
    GeneralInvoice,
    SpecialInvoice,
    PersonalInvoice
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    companyId: {
      type: [String, Number],
      required: true
    },

    amount: {
      type: Number,
      default: 0
    },

    // 实付金额(用于判断是否可以开专票)
    accountBalance: {
      type: Number,
      default: 0
    },

    ids: {
      type: Array,
      default: () => []
    },

    // 收费类型
    chargeType: {
      type: [Number, String],
      required: true
    },

    // 开票类别
    applyType: {
      type: [Number, String],
      required: true
    },

    // 是否本公司
    isOurCompanyId: {
      type: Number,
      default: isWhetherOurCompanyDict.NO.value
    }
  },

  data() {
    return {
      invoiceTitleTypeDict,
      invoiceTypeDict,
      invoiceTypeList: [],
      invoiceType: invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value,
      invoiceInfo: {},
      // buyerId: '',
      // 发票抬头
      invoiceTitle: invoiceTitleTypeDict.COMPANY.value,
      // 发票列表
      invoiceTitleList: [],
      // 发票下标
      invoiceIndex: 0
    }
  },

  computed: {
    ...mapState('user', ['companyList']),

    // 选择个人抬头类型
    inPersonalInvoice() {
      return this.invoiceTitle === invoiceTitleTypeDict.PERSONAL.value
    },

    // 选择普通发票/数电普票
    inGeneralInvoice() {
      return (
        this.invoiceType === invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value ||
        this.invoiceType === invoiceTypeDict.INVOICE_NORMAL_YONYOU.value
      )
    },

    drawerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },

    // 显示专票选项
    showInvoiceTypeRadio() {
      // 如果选择个人抬头，则不允许选择普票或专票
      if (this.inPersonalInvoice) {
        return false
      }

      // // 仅服务费、平台增值服务两种费用支持开专票
      // // PRD地址：https://jczh.yuque.com/ffgs6r/umof7l/dagyrg
      // // 服务费金额小于2000时，只能开电子普票，大于等于2000时，支持开专票
      // // 需求地址：https://devops.aliyun.com/projex/project/388312a8af23c6e4d7e897e29f/req/5fc22109f6ef466cff22053de7
      // if (
      //   this.chargeType === feeTypeDict.SERVICE_FEE_PAY.value &&
      //   this.accountBalance >= 2000
      // ) {
      //   return true
      // }

      // // 增值服务费金额大于等于2000时，支持开专票
      // if (
      //   this.chargeType === feeTypeDict.VAS.value &&
      //   this.accountBalance >= 2000
      // ) {
      //   return true
      // }

      // // 技术服务费金额大于等于2000时，支持开专票
      // if (
      //   this.chargeType === feeTypeDict.AGENT_SERVICE_FEE_PAY.value &&
      //   this.accountBalance >= 2000
      // ) {
      //   return true
      // }

      // return false

      return true
    },

    // 显示开票企业选择操作
    showCompanySelect() {
      // 如果不是个人付费类型，则不允许选择开票企业
      if (this.chargeType !== feeTypeDict.VAS.value) {
        return false
      }
      // 如果选择个人抬头，则不允许选择开票企业
      if (this.inPersonalInvoice) {
        return false
      }
      return true
    },

    // 显示发票抬头选择操作
    showInvoiceTitleSelect() {
      // 仅个人付费类型支持选择发票抬头
      if (this.chargeType === feeTypeDict.VAS.value) {
        return true
      }
      return false
    },

    // 当前发票简要信息
    currentInvoiceTitle() {
      return (
        this.invoiceTitleList[this.invoiceIndex] || {
          companyId: '',
          invoiceAddressId: '',
          invoiceTitle: '',
          invoiceName: ''
        }
      )
    }
  },

  watch: {
    drawerVisible(val) {
      if (val) {
        const {
          GENERAL_ELECTRONIC_INVOICE,
          SPECIAL_PAPER_INVOICE,
          INVOICE_NORMAL_YONYOU,
          INVOICE_SPECIAL_YONYOU
        } = invoiceTypeDict

        // 本公司收费：数电普票，数电专票；非本公司：普票，专票
        this.invoiceTypeList =
          this.isOurCompanyId === isWhetherOurCompanyDict.YES.value
            ? [INVOICE_NORMAL_YONYOU, INVOICE_SPECIAL_YONYOU]
            : [GENERAL_ELECTRONIC_INVOICE, SPECIAL_PAPER_INVOICE]

        this.invoiceType =
          this.isOurCompanyId === isWhetherOurCompanyDict.YES.value
            ? INVOICE_NORMAL_YONYOU.value
            : GENERAL_ELECTRONIC_INVOICE.value

        this.setInvoiceListData()
      }
    }
  },

  methods: {
    /**
     * 关闭侧边抽屉
     */
    handleDrawerClose() {
      if (this.$refs?.personalInvoice) {
        if (this.$refs?.personalInvoice.$data.invoiceInfo.id) {
          this.$refs?.personalInvoice?.cancel()
        }
      }
      if (this.$refs?.generalInvoice) {
        if (this.$refs?.generalInvoice.$data.invoiceInfo.id) {
          this.$refs?.generalInvoice?.cancel()
        }
      }
      if (this.$refs?.specialInvoice) {
        if (this.$refs?.specialInvoice.$data.invoiceInfo.id) {
          this.$refs?.specialInvoice?.cancel()
        }
      }
      this.invoiceType = invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value
      this.invoiceTitle = invoiceTitleTypeDict.COMPANY.value
      // this.buyerId = this.companyId
    },

    getInvoiceInfo(info) {
      this.invoiceInfo = info
    },

    // 确认申请
    async confirmApply() {
      if (this.$refs?.personalInvoice) {
        if (!this.$refs?.personalInvoice.$data.invoiceInfo.id) {
          this.$message.warning('请先生成发票信息')
          return
        }
        this.$refs?.personalInvoice?.cancel()
      }
      if (this.$refs?.generalInvoice) {
        if (!this.$refs?.generalInvoice.$data.invoiceInfo.id) {
          this.$message.warning('请先生成发票信息')
          return
        }
        this.$refs?.generalInvoice?.cancel()
      }
      if (this.$refs?.specialInvoice) {
        if (!this.$refs?.specialInvoice.$data.invoiceInfo.id) {
          this.$message.warning('请先生成发票信息')
          return
        }
        this.$refs?.specialInvoice?.cancel()
      }

      try {
        await this.$confirm('是否申请开票', '系统提示', { type: 'warning' })
        const postData = {
          ids: this.ids,
          chargeType: this.chargeType,
          applyType: this.applyType,
          invoiceAddressId: this.invoiceInfo.id
        }

        const res = await applyInvoiceApi(postData)
        this.$message.success(res.data?.message || '申请成功')
        this.drawerVisible = false
        this.$emit('afterConfirm')
      } catch (err) {
        if (err?.data) {
          this.$message.error(err?.data?.message || '申请开票失败')
        }
      }
    },

    /**
     * 获取发票抬头列表
     */
    setInvoiceListData() {
      getInvoiceCompanyApi()
        .then(res => {
          this.invoiceTitleList = []
          const customList = res.data.map(item => {
            return {
              invoiceName: item.companyName,
              invoiceTitle: item.companyTaxNo,
              invoiceTitleType: invoiceTitleTypeDict.COMPANY.value,
              isCustomize: true,
              companyId: 0,
              employeeId: 0,
              invoiceAddressId: item.id
            }
          })
          this.invoiceTitleList = this.invoiceTitleList.concat(customList)
          this.$store
            .dispatch('user/getJoinedCompany')
            .then(() => {
              const tempList = this.companyList.map(item => {
                return {
                  invoiceName: item.companyName,
                  invoiceTitle: item.companyName,
                  invoiceTitleType: invoiceTitleTypeDict.COMPANY.value,
                  isCustomize: false,
                  companyId: item.companyId,
                  employeeId: item.employeeId
                }
              })
              this.invoiceTitleList = this.invoiceTitleList.concat(tempList)
              // 如果传入的companyId有值，则查找对应的发票抬头
              if (this.companyId) {
                this.invoiceIndex = this.invoiceTitleList.findIndex(
                  item => item.companyId === this.companyId
                )
              }
            })
            .catch(err => {
              console.error('获取发票列表失败', err)
              if (err?.message) this.$message.error(err.message)
            })
        })
        .catch(err => {
          console.error('获取发票列表失败', err)
          if (err?.data?.message) this.$message.error(err.data.message)
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
